// extracted by mini-css-extract-plugin
module.exports = {"hidden":"fileAttachment_hidden__gJzeZ","textEmphasis":"fileAttachment_textEmphasis__jsniQ","noticeArea":"fileAttachment_noticeArea__FXKjf"};